export default "__VITE_ASSET__abdf3334__"